import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/';
import GrupoFamiliar from '../components/grupo-familiar';





const mapStateToProps = (state, ownProps) => {

    return {...state.solicitacao.grupoFamiliar, perDtFim: state.solicitacao.cursoInteresse.perDtFim};
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        removeItemArquivoFamilia: (indice) => {
            dispatch(actions.removeItemArquivoFamilia(indice));
        },

        onSaveFile: (origem, descricao, arquivoBytes, indice) => {
            dispatch(actions.saveItemArquivoFamilia(descricao, arquivoBytes, indice));
        },

        updatePessoaGrupoFamiliar: (indice, item) => {
            dispatch(actions.updatePessoaGrupoFamiliar(indice, item));
        },

        deletePessoaGrupoFamiliar: (indice) => {
            dispatch(actions.deletePessoaGrupoFamiliar(indice));
        },

        addErro: (erro) => {
            dispatch(actions.setError(new Error(erro)));
        },

        addPessoaGrupoFamiliar: (pessoa) => {
            dispatch(actions.addPessoaGrupoFamiliar(pessoa));
        },

        addCadastroNoGrupoFamiliar: () => {
            dispatch(actions.addCadastroNoGrupoFamiliar());
        },

        changeCampoGenericoFamiliar: (campoState, valor) => {
            dispatch(actions.changeCampoGenericoFamiliar(campoState, valor));
        }

    };
};

const GrupoFamiliarContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(GrupoFamiliar);


export default GrupoFamiliarContainer;


// WEBPACK FOOTER //
// ./src/containers/grupo-familiar.js